import { createAction } from "@reduxjs/toolkit";
import { HYDRATE } from "next-redux-wrapper";

export const hydrate = createAction(HYDRATE);
